import { apiClient } from "../lib/api-client";

export const subscriptionService = {
    async createCheckout(variantId: string): Promise<string> {
        const response = await apiClient.post<{ checkoutUrl: string }>(
            "/subscriptions/checkout",
            { variantId }
        );
        if (response.success && response.data) {
            return response.data.checkoutUrl;
        }
        throw new Error(response.message || "Failed to initiate checkout");
    },

    async getPortalUrl(): Promise<string> {
        const response = await apiClient.get<{ portalUrl: string }>(
            "/subscriptions/portal"
        );
        if (response.success && response.data) {
            return response.data.portalUrl;
        }
        throw new Error(response.message || "Failed to get customer portal");
    }
};
